<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content [innerHTML]="content"></div>
<div mat-dialog-actions>
  <div class="buttons-scroll-wrapper">
    <button mat-button mat-dialog-close (click)="clickNo()">{{ noText }}</button>
    <button mat-button mat-dialog-close cdkFocusInitial (click)="clickOk()" class="btn-yes">
      {{ yesText }}
    </button>
  </div>
</div>
